/*
 * @Description: 商机及商机管理有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  角色: '角色',
  完成: '完成',
  部门: '部门',
  产品: '产品',
  价格: '价格',
  币种: '币种',
  折扣: '折扣',
  数量: '数量',
  小计: '小计',
  原因: '原因',
  '回退后，若已完成的阶段内有审批任务，需要重新提交审批': '回退后，若已完成的阶段内有审批任务，需要重新提交审批',
  暂不: '暂不',
  结束: '结束',
  负责人: '负责人',
  有效期: '有效期',
  未开始: '未开始',
  进行中: '进行中',
  已完成: '已完成',
  云文档: '云文档',
  本地附件: '本地附件',
  标准价格: '标准价格',
  规格单位: '规格单位',
  时长单位: '时长单位',
  销售单价: '销售单价',
  商机导入: '商机导入',
  转移商机: '转移商机',
  商机产品: '商机产品',
  产品信息: '产品信息',
  新增产品: '新增产品',
  编辑产品: '编辑产品',
  基本信息: '基本信息',
  系统信息: '系统信息',
  商机来源: '商机来源',
  商机阶段: '商机阶段',
  商机金额: '商机金额',
  关单日期: '关单日期',
  暂无配置: '暂无配置',
  上传出错: '上传出错',
  上传成功: '上传成功',
  协作阶段: '协作阶段',
  绩效比例: '绩效比例',
  选择价格: '选择价格',
  产品名称: '产品名称',
  变更原因: '变更原因',
  业绩参与人: '业绩参与人',
  参与人角色: '参与人角色',
  未发现客户: '未发现客户',
  请选择价格: '请选择价格',
  请选择币种: '请选择币种',
  请输入数量: '请输入数量',
  本阶段任务: '本阶段任务',
  本阶段无任务: '本阶段无任务',
  新增协作阶段: '新增协作阶段',
  是否确认删除: '是否确认删除？',
  已过期价格不可选: '已过期价格不可选',
  请输入销售单价: '请输入销售单价',
  新增业绩参与人: '新增业绩参与人',
  编辑业绩参与人: '编辑业绩参与人',
  阶段变更成功: '阶段变更成功',
  批量转移商机: '批量转移商机',
  请输入回退原因: '请输入回退原因',
  请选择产品名称: '请选择产品名称',
  推进至当前阶段: '推进至当前阶段',
  回退至当前阶段: '回退至当前阶段',
  推进至下一阶段: '推进至下一阶段',
  当前阶段任务已全部完成: '当前阶段任务已全部完成',
  请点击上传本地附件: '请点击上传本地附件',
  商机详情EXCEL模板: '商机详情EXCEL模板',
  请确认是否删除该产品: '请确认是否删除该产品',
  暂无此商机查看权限: '暂无此商机查看权限',
  请先完成上一阶段全部任务: '请先完成上一阶段全部任务',
  不支持转移的商机名称如下: '不支持转移的商机名称如下',
  请填写阶段变更原因: '请填写阶段变更原因', //-
  商机列表: '商机列表',
  请选择业绩参与人: '请选择业绩参与人',
  只能选择一个业绩参与人: '只能选择一个业绩参与人',
  请输入产品价格: '请输入产品价格',
  请选择有效期: '请选择有效期',
  产品价格: '产品价格',
  是必填项: '是必填项',
  新增Call款: '新增Call款',
  新增协议: '新增协议'
};
